require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js
// module id = ./node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js
// module chunks = 0